export default {
  removeNonNumeric(str: string = ''): number {
    const isNegative = str?.trim().startsWith('-');
    const cleaned = str?.replace(/[^0-9.,]/g, '');
    const value = parseFloat(cleaned);

    return isNegative ? -value : value;
  },
  formatToStringWithThousandsSeparator(
    value: number,
    cultureCode: string,
    minimumFractionDigits = 0,
  ): string {
    const cultureInfo = cultureCode || Intl.DateTimeFormat().resolvedOptions().locale;
    return value.toLocaleString(cultureInfo, {
      minimumFractionDigits: minimumFractionDigits,
      maximumFractionDigits: 6,
    });
  },
};
